module.exports = __webpack_public_path__ + "static/media/stormy_weather.64fec8b1.png";